(function () {
    var $stepContainer = $('.js-pda-step');
    var $pdaForm = $('.js-pda-form')
    var $htmlBody = $('html, body');

    var inputSizeStep1;
    var $inputStep1;

    var inputSizeStep2;
    var $inputStep2;

    // Config
    var $conf = $('.js-conf');

    // Char counter instance
    var $textareaComment = $('.js-textAreaCounter').find('textarea');
    var $counterControl = $('.js-counterComment');
    // Char cunter for textarea
    // TAG: FORMRESTRICTIONS
    var charCounter = new CharCounter({
        controlToLimit: $textareaComment,
        counterControl: $counterControl,
        maxCharacters: 6000
    });

    // Spinner instance
    var spinner = spinner = new Spinner({
        $selectSpinner: $('.js-spinner'),
        spinnerState: true
    });

    // Go to Pda test button
    var footerHeight;
    var $applyAffix = $('.js-go-to-pda, .js-pda-opts-counter');
    var $pdaFinishModal = $('.js-pda-finish-modal');

    function pdaServices() {
        $pdaForm.on('submit', function (event) {
            var jqxhr;
            var $form = $(this);

            event.preventDefault();
            eeGlobal.notification.clean();

            if ($form.valid()) {
                spinner.toggle();

                jqxhr = $.ajax({
                    type: $form.attr('method'),
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    dataType: 'json',
                    cache: false
                });

                jqxhr.done(function (response) {
                    spinner.toggle();

                    if (!response.isOk) {
                        if (response.isTime) {
                            eeGlobal.notification.warning({
                                title: response.title,
                                copy: response.message,
                                scroll: true
                            });
                        } else {
                            eeGlobal.notification.danger({
                                title: response.title,
                                copy: response.message,
                                scroll: true
                            });
                        }

                        return;
                    }

                    //Ga4 pda test
                    var data = $(this).data("ga4pda");
                    behavioral_test(data);

                    pdaFinishBind(response.url);
                    $pdaFinishModal.modal('show');

                    $form[0].reset();
                });

                jqxhr.fail(function (jqXHR, textStatus, errorThrown) {
                    eeGlobal.notification.danger({
                        title: 'Error',
                        copy: errorThrown
                    });
                });
            }
        });
    }

    function pdaCounter() {
        var $pageContainer;
        var $options;

        $pageContainer = $('[id^="step-"]');

        $.each($pageContainer, function (index, element) {
            var $this = $(element);
            var $options;
            var selected;
            var totalOpts;
            var $infoSelected;
            var $countModal;
            var $nextButton;
            var $input;
            var objectLength;

            $options = $this.find('.js-custom-input');
            // $input = $options;
            // objectLength = $input.length;/

            if ($options.length) {

                $this.find("input:checked").prop('checked', false);

                selected = 0;
                totalOpts = $options.length;
                $infoSelected = $this.find('.js-pda-opts-counter');
                $countModal = $this.find('.js-pda-opts-counterModal');
                $nextButton = $this.find('.js-validate-Button').eq(1);


                $infoSelected.text('Seleccionados ' + selected);
                $countModal.text(selected);

                $options.on('click', function () {
                    var $option = $(this);
                    if ($option.is(':checked')) {
                        selected++;
                    } else {
                        selected--;
                    }
                    if (selected >= 19) {
                        if (selected >= 75) {
                            for (var i = 0; i < totalOpts; i++) {
                                if (!(($options).get(i).checked)) {
                                    $options.eq(i).prop('disabled', true);
                                }
                            }
                            $htmlBody.animate({
                                scrollTop: $(document).height()
                            }, 500);
                        } else {
                            for (var i = 0; i < totalOpts; i++) {
                                if (!(($options).get(i).checked)) {
                                    $options.eq(i).prop('disabled', false);

                                }
                            }
                        }
                    }
                    $infoSelected.text('Seleccionados ' + selected);
                    $countModal.text(selected);
                });
            }
        });
    }

    function newValidation() {

        $pageContainer = $('[id^="step-"]');


        $.each($pageContainer, function (index, element) {
            var $this = $(element);
            var selected;
            var $nextButton
            var totalOpts
            $this.find("input:checked").prop('checked', false);
            selected = 0;
            $options = $this.find('.js-custom-input');
            totalOpts = $options.length;
            $nextButton = $this.find('.js-validate-Button');

            $nextButton.on('click', function () {
                selected = 0;
                for (var i = 0; i < totalOpts; i++) {
                    var $option = $this.find('.js-custom-input');
                    if (($option).get(i).checked) {
                        selected++;
                    }
                }

                if (selected >= 19) {

                    //Ga4 pda test
                    var data = $(this).data("ga4pda");
                    behavioral_test(data);

                    step = $nextButton.data('step');
                    $htmlBody.animate({
                        scrollTop: $pdaForm.offset().top - 91
                    }, 500, function () {
                        if (step != 0) {
                            $('.stepwizard a[href="#step-' + step + '"]').tab('show');
                        }
                    });


                } else {
                    switch ($nextButton.data('step')) {

                        case 2:
                            $('#ModalStep1').modal('show');
                            break;

                        case 3:
                            $('#ModalStep2').modal('show');
                            break;
                    }
                }
            })
        })
    };

    function pdaFinishBind(url) {
        var $pdaFinishBtn = $('.js-pda-finish-btn');

        $pdaFinishBtn.off();

        $pdaFinishBtn.on('click', function (event) {
            event.preventDefault();

            //Ga4 pda test
            var data = $(this).data("ga4pda");
            behavioral_test(data);

            document.location = url;
        });
    }

    $stepContainer.on('click', function () {
        step = $(this).data('step');
        $htmlBody.animate({
            scrollTop: $pdaForm.offset().top - 91
        }, 500, function () {
            if (step != 0) {
                $('.stepwizard a[href="#step-' + step + '"]').tab('show');
            }
        });

        //Ga4 pda test
        var data = $(this).data("ga4pda");
        behavioral_test(data);
    });

    pdaServices();
    pdaCounter();


    newValidation();

    // Apply affix for go to pda button
    $applyAffix.affix({
        offset: {
            bottom: function () {
                var addHeightForBtn;

                if ($applyAffix.hasClass('js-pda-opts-counter')) {
                    addHeightForBtn = eeGlobal.mqDetector.isDevice('sm', 'md') ? 160 : 140;
                } else {
                    addHeightForBtn = 110;
                }

                footerHeight = $('.footer').outerHeight() + addHeightForBtn;
                return footerHeight;
            }
        }
    });
})();
